import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import headersMap from "../assets/modules/headersMap";
import apiService from "../services/apiService";
import { ToastContainer, toast } from "react-toastify";

function Bulk_table() {
  const location = useLocation();
  const navigate = useNavigate();

  const payload = location.state?.payload || {};
  const { file, fileName, importType, apiResponse } = payload;

  console.log("Received payload:", payload);  

  const headers = headersMap[importType] || headersMap["content"];

  const handleSubmit = async () => {
    if (!importType || !fileName) {
      toast.error("Please enter a valid Import Type");
      return;
    }
  
    const formData = new FormData();
    formData.append("import_type", importType);  
    formData.append("file_name", fileName); 
    formData.append("file", file); 
  
    try {
      const response = await apiService.postData(
        "admin/upload-csv/insert",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      console.log("Full API Response:", response); // Debug
  
      const resData = response;
  
      if (resData?.error === false) {
        const insertedData = resData.data;
        const insertedCount = Array.isArray(insertedData) ? insertedData.length : 1;
  
        toast.success(`${insertedCount} record${insertedCount > 1 ? "s" : ""} inserted successfully!`);
        navigate("/bulk_upload");
      } else {
        toast.error(resData?.message || "Failed to insert data.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };
  
  
  const hasErrors =
  payload?.data?.isError ||
  (Array.isArray(apiResponse) &&
    apiResponse.some((row) => row.error && row.error.length > 0));

  return (
    <div className="container mt-4">
      <ToastContainer />

<h5 className="text-dark">
  Bulk Table:{" "}
  <span className="text-primary">
    {((Object.keys(headersMap).find(key => headersMap[key] === headers) || importType) || "").replace(/^./, str => str.toUpperCase())}
  </span>
</h5>


      <div className="table-responsive border mt-3">
        <table className="table text-center">
          <thead className="table-light">
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {apiResponse && apiResponse.length > 0 ? (
              apiResponse.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {headers.map((header, colIndex) => (
                    <td key={colIndex}>
                      {row[header.key] !== undefined ? row[header.key] : "-"}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={headers.length} className="text-danger">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="mt-3">
        <button onClick={() => navigate(-1)} className="btn btn-danger me-2">
          Back
        </button>
        {/* <button onClick={handleSubmit} className="btn btn-primary">
          Submit
        </button> */}
        <button
  onClick={handleSubmit}
  className="btn btn-primary"
  disabled={hasErrors}
>
  Submit
</button>
{hasErrors && (
  <div className="text-danger mt-2">
    Please fix the errors before submitting.
  </div>
)}

      </div>
    </div>
  );
}

export default Bulk_table;
